import { render } from "./Symptoms.vue?vue&type=template&id=5751a3be&scoped=true"
import script from "./Symptoms.vue?vue&type=script&lang=js"
export * from "./Symptoms.vue?vue&type=script&lang=js"

import "./Symptoms.vue?vue&type=style&index=0&id=5751a3be&scoped=true&lang=css"

import exportComponent from "/usr/home/demon/projects/driven/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5751a3be"]])

export default __exports__